import { useCurrentSessionUserField } from '@ms/yammer-hooks/dist/session';

import type { UseUIFeatureCheck } from '../types';

export const useIsGroupsEnabled: UseUIFeatureCheck = () => !useCurrentSessionUserField('isGuest');
